export default class LocalStorageService {
    constructor() { }

    public SaveFavouriteEventOrganisers(accountId: string) {
        var localStorageValue = localStorage.getItem('tbeos');
        var separator = ',';
        var favouriteEos = new Array();

        if (localStorageValue !== null) {
            favouriteEos = atob(localStorageValue).split(separator);
        }

        if (favouriteEos.indexOf(accountId) <= -1) {
            favouriteEos.push(accountId);
            localStorage.setItem('tbeos', btoa(favouriteEos.join(separator)));
        }   
    }
}